function getDifferenceOnDays(
  firstDate: Date,
  secondDate: Date,
  includeEndDate = true
): number {
  return (
    Math.round((secondDate.getTime() - firstDate.getTime()) / (1000 * 60 * 60 * 24)) +
    (includeEndDate ? 1 : 0)
  )
}

export default getDifferenceOnDays
